import { TagBox } from "devextreme-react/tag-box";
import get from "lodash/get";
import includes from "lodash/includes";
import isArray from "lodash/isArray";
import trim from "lodash/trim";
import React, { memo, useRef } from "react";
const emptyArray = [];
function TagsWidget({ className, width, value, onChange, placeholder, maxDisplayedTags, readOnly, disabled, fieldName, ...other }) {
    const inputText = useRef(null);
    const handleCustomItemCreating = (e) => {
        if (e.customItem)
            return;
        const text = trim(e.text);
        e.customItem = text && !includes(value, text) ? text : null;
    };
    const handleColumnsTextBoxChange = ({ value: newValue, event }) => {
        if (event) {
            inputText.current = null;
            onChange && onChange(newValue, fieldName);
        }
    };
    const handleKeyUp = (e) => {
        inputText.current = get(e.component.field(), "value");
    };
    const handleBlur = () => {
        const text = trim(inputText.current || "");
        text &&
            !includes(value, text) &&
            onChange &&
            onChange([...(value || emptyArray), text], fieldName);
        inputText.current = null;
    };
    return (React.createElement(TagBox, { className: className, width: width, maxDisplayedTags: maxDisplayedTags, acceptCustomValue: true, placeholder: placeholder, showClearButton: true, opened: false, openOnFieldClick: false, onInput: handleKeyUp, onFocusOut: handleBlur, value: !value || !isArray(value) ? undefined : value, onValueChanged: handleColumnsTextBoxChange, onCustomItemCreating: handleCustomItemCreating, spellcheck: false, readOnly: readOnly, disabled: disabled, ...other }));
}
export default memo(TagsWidget);
TagsWidget.defaultProps = {
    maxDisplayedTags: undefined
};
